// extracted by mini-css-extract-plugin
export default {"melodyVideo":"XI-z","isFullWidth":"YI-z","landingPageVideo":"ZI-z","play":"_I-z","iframeVideo":"aJ-z","playHidden":"bJ-z","fullwidth":"cJ-z"};